import { t } from "@lingui/macro";
import { useDialog } from "@/client/stores/dialog";
import {
  Badge,
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@reactive-resume/ui";
import { CheckCircleIcon, XCircleIcon, ClockIcon } from "@phosphor-icons/react";
import { usePayment } from "@/client/services/payment/payment";

export const GetPaymentDialog = () => {
  const { isOpen, close, payload } = useDialog<{ id: string }>("get-payment");
  const { payment } = usePayment(payload?.item?.id ?? "");

  if (payment) {
    const getStatusBadge = (status: number) => {
      switch (status) {
        case 0:
          return <Badge variant="warning">En attente</Badge>;
        case 1:
          return <Badge variant="success">Payé</Badge>;
        case 2:
          return <Badge variant="error">Annulé</Badge>;
        default:
          return (
            <Badge className="border-0 bg-admin-surface-hover text-admin-text-secondary">
              Inconnu
            </Badge>
          );
      }
    };

    return (
      <Dialog open={isOpen} onOpenChange={close}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Details du paiement</DialogTitle>
          </DialogHeader>
          <div className="grid-row-5 grid grid-cols-2 gap-2">
            <div className="border-secondary border-b-2 font-bold">Reference</div>
            <div className="border-secondary border-b-2"> {payment.reference} </div>
            <div className="border-secondary border-b-2 font-bold">Montant</div>
            <div className="border-secondary border-b-2">{payment.Amount}</div>
            <div className="border-secondary border-b-2 font-bold">Utilisateur</div>
            <div className="border-secondary border-b-2">{payment.user?.name}</div>
            <div className="border-secondary border-b-2 font-bold">Coupon</div>
            <div className="border-secondary border-b-2">{payment.coupon?.code || "N/A"}</div>
            <div className="border-secondary border-b-2 font-bold">{t`Tarif`}</div>
            <div className="border-secondary border-b-2">{payment.rate?.name || "N/A"}</div>
            <div className="border-secondary border-b-2 font-bold">Date d'ouverture</div>
            <div className="border-secondary border-b-2">
              {new Date(payment.openDate).toDateString()}
            </div>
            <div className="border-secondary border-b-2 font-bold">Date de cloture</div>
            <div className="border-secondary border-b-2">
              {payment.closeDate ? new Date(payment.closeDate).toDateString() : "/"}
            </div>

            <div className="border-secondary border-b-2 font-bold">Statut</div>
            <div className="border-secondary border-b-2">{getStatusBadge(payment.status)}</div>
          </div>
        </DialogContent>
        <DialogFooter></DialogFooter>
      </Dialog>
    );
  }
};
